import React from 'react';
import './LandingPage.css';
import Carousel from '../../components/Carousel/Carousel';

export default function LandingPage() {
    return (
        <div className="landing-page">
            <Carousel />
        </div>
    )
}
